module.exports = __webpack_public_path__ + "img/aParty_121223_H.3527f202.jpg";